import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';

import { Link } from 'react-router';

const setAgency = agency => dispatch =>
	dispatch({
		type: 'agency/select',
		agency: agency,
	});

const toggleAgency = () => dispatch =>
	dispatch({
		type: 'agency/toggle',
	});

const CodeToggle = ({ agency, setAgency, toggleAgency }) => {

	const toggleClass = classNames({
		"fa fa-toggle-on fa-lg": true,
		"fa-flip-horizontal": agency === 'tab',
		"tab": agency === 'tab',
		"ubet": agency === 'ubet',
	})

	return (
		<div className="flex pointer">
			<div className="flex1 centre" onClick={() => setAgency('tab')}>TAB</div>
			<div className="flex1 centre"  onClick={() => toggleAgency()}>
				<i className={toggleClass} aria-hidden="true"></i>
			</div>
			<div className="flex1 centre" onClick={() => setAgency('ubet')}>UBET</div>
		</div>
	)
}

let Banner = ({ date, agency, setAgency, toggleAgency }) => {
	const skyClick = () => {
		window.location = `http://schedule.skychannel.com.au/day.php?day=${moment(date).format('DD')}&month=${moment(date).format('MM')}&year=${moment(date).format('YYYY')}`;
	};

	const openGuides = () => {
		window.location = `guides://${moment(date).format('YYYY-MM-DD')}`;
	};

	const DateLink = ({ url, icon = "", children }) => (
		<Link
			to={url}
			activeStyle={{
				textDecoration: 'none',
			}}
			className={icon}
		>
			{children}
		</Link>
	);
	DateLink.propTypes = {
		url: PropTypes.string,
		children: PropTypes.string,
	};

	return (
		<div className="banner">
			<div className="flex5 left flex dates">
				<div className="flex1 left">
					<DateLink url={ moment(date).subtract(1, 'days').format('YYYY-MM-DD') } icon="fa fa-chevron-left">
					</DateLink>
				</div>
				<div className="flex8 label">
					<DateLink url={ moment().add(1, 'days').format('YYYY-MM-DD') }>{moment(date).format('dddd, MMMM D')}</DateLink>
				</div>
				<div className="flex1 right">
					<DateLink url={ moment(date).add(1, 'days').format('YYYY-MM-DD') } icon="fa fa-chevron-right">
					</DateLink>
				</div>
			</div>
			<div className="flex4"></div>
			<div className="flex2">
				<CodeToggle
					agency={agency}
					setAgency={setAgency}
					toggleAgency={toggleAgency}
				/>
			</div>
			<div className="flex3"></div>
			<div className="flex3 right"><button onClick={skyClick}>Sky Coverage</button></div>
			<div className="flex3 centre"><button onClick={openGuides}>Open Guides</button></div>
		</div>
	);
};
Banner.propTypes = {
	date: PropTypes.string,
	agency: PropTypes.string,
	toggleAgency: PropTypes.func,
	setAgency: PropTypes.func,
};

Banner = connect(
	({ agency }, { date }) => ({ agency, date }),
	{ toggleAgency: toggleAgency, setAgency: setAgency },
)(Banner);

export default Banner;


/** WEBPACK FOOTER **
 ** ./src/components/banner.jsx
 **/